import { render, staticRenderFns } from "./OrgBlockingHistory.vue?vue&type=template&id=1cfdb978"
import script from "./OrgBlockingHistory.vue?vue&type=script&lang=js"
export * from "./OrgBlockingHistory.vue?vue&type=script&lang=js"
import style0 from "./OrgBlockingHistory.vue?vue&type=style&index=0&id=1cfdb978&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports